window.addEventListener('resize', function ()  {
  var x = document.documentElement.clientWidth
  var scale = x/750
  var html = document.getElementsByTagName('html')[0]
  html.style.fontSize= 200 * scale + 'px'
})
window.addEventListener('load', function () {
  var x = document.documentElement.clientWidth
  var scale= x/750
  var html = document.getElementsByTagName('html')[0]
  html.style.fontSize= 200 * scale + 'px'
})